module.exports = function() {
  return new Worker(__webpack_public_path__ + "fe36c3f21d357334e208.worker.js");
};